import VLink from './VLink.vue';
import utile from '../../utile';

export default {
  getComponentByConfig(config) {
    return utile.resetComponentByConfig(config, 'vLink', VLink);
  },
};
